function ProductCard({ product, onViewImage }) {
  const mainImage = product.images?.[0];

  return (
    <article className="product-card">
      <button
        className="product-image-wrap"
        type="button"
        onClick={() => onViewImage(product)}
        aria-label={`View details for ${product.name}`}
      >
        {mainImage ? (
          <img
            src={mainImage.src}
            alt={mainImage.alt || product.name}
            className="product-image"
            loading="lazy"
          />
        ) : (
          <div className="product-image-placeholder">
            <span>Coming soon</span>
          </div>
        )}

        <span className="product-view-badge">View options</span>
      </button>

      <div className="product-content">
        <p className="product-category">{product.category}</p>
        <h3>{product.name}</h3>
        <p className="product-description">{product.description}</p>
      </div>

      <div className="product-bottom">
        <span>
          {product.startingPrice?.startsWith("From")
            ? product.startingPrice
            : `From ${product.startingPrice}`}
        </span>

        <button
          className="product-details-btn"
          type="button"
          onClick={() => onViewImage(product)}
        >
          View details
        </button>
      </div>
    </article>
  );
}

export default ProductCard;